module.exports = __webpack_public_path__ + "static/media/home-icon.9f28f3e6.svg";